import type { SVGProps } from 'react';

// Custom gear icon (from design) used in place of lucide's Settings2 for the
// experiment timeline's "gear" checkpoint marker. Strokes use currentColor so
// it inherits the surrounding badge's text color like the lucide icons do.
export function GearIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9603 6.10611L12.72 5.76594M12.6654 3.85363L11.8874 3.55656M13.9796 2.46215L13.6386 1.70241M14.1115 7.0801L13.8144 7.8589M15.8921 2.40752L16.1892 1.62956M16.3642 7.78606L16.024 7.02547M17.2835 3.72171L18.0441 3.38069M17.3382 5.63402L18.117 5.93107M17.5008 4.67236C17.5402 6.05251 16.4534 7.2033 15.0732 7.24273C13.6931 7.28215 12.5423 6.19528 12.5028 4.81513C12.4634 3.43498 13.5503 2.28419 14.9304 2.24477C16.3106 2.20534 17.4614 3.29222 17.5008 4.67236Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.78321 12.2915L3.27939 12.2651M4.53834 9.06475L3.46168 8.02467M7.69295 7.69128L7.6652 6.19453M4.65277 15.4197L3.61215 16.4978M10.8936 8.95033L11.9336 7.87362M7.8792 18.1764L7.8534 16.6788M12.2669 12.105L13.765 12.0777M11.0079 15.3054L12.086 16.346M11.9553 13.8301C11.0467 16.1398 8.43778 17.2757 6.12808 16.3672C3.81838 15.4586 2.68256 12.8496 3.59117 10.5398C4.49978 8.23005 7.10873 7.09415 9.41843 8.00273C11.7281 8.9113 12.8639 11.5203 11.9553 13.8301Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
